import React from "react"

import { GET_WHW_FILTERS } from "../../../graphql/queries/filters"
import useAppSyncQuery from "../../../hooks/useAppSyncQuery"
import AwardsChips from "../components/AwardsChips"
import AwardRankingBanner from "../components/AwardsRankingBanner/AwardRankingBanner"
import DesktopHappiestWorkplacesForYouDiv from "../components/DesktopHappiestWorkplacesForYouDiv"
import SideCards from "../components/SideCards"
import SocialsBanner from "../components/SocialsBanner"
import { loadWHWFilters, loadWHWFiltersFail, loadWHWFiltersSuccess } from "../store/rankings.actions"
import { CustomBox, TableWrapper } from "../styles"
import HappiestCompaniesContent from "./happiestCompaniesContent"

export default function HappiestCompanies() {
  useAppSyncQuery(GET_WHW_FILTERS, {
    variables: {},
    isPublic: true,
    initAction: loadWHWFilters,
    successAction: loadWHWFiltersSuccess,
    failAction: loadWHWFiltersFail
  })

  return (
    <CustomBox width={1 / 1} mx="auto">
      <AwardRankingBanner />
      <AwardsChips />
      <DesktopHappiestWorkplacesForYouDiv />
      <TableWrapper flexDirection={["column", "column", "row"]}>
        <HappiestCompaniesContent />
        <SideCards />
      </TableWrapper>
      <SocialsBanner />
    </CustomBox>
  )
}
